import { InjectionToken } from '@angular/core';

export const CONTACTS_AUX_BASE_PATH = new InjectionToken<string>('CONTACTS_AUX_BASE_PATH');
export const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}
